import React from 'react';
import PaginationBase from '../../../common/base/PaginationBase';
import { message } from 'antd';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import { SOLES, DOLARES_AMERICANOS } from '../../../common/types/monedaType';
import { LOGISTICA } from '../../../common/types/sistemaType'
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';

import monedaService from '../../../service/administracion/monedaService';
import listaPrecioService from '../../../service/administracion/listaPrecioService';
import tipoCambioDiarioService from '../../../service/administracion/tipoCambioDiarioService';
import establecimientoService from '../../../service/administracion/establecimientoService';
import almacenService from '../../../service/administracion/almacenService';
import tipoComprobanteService from '../../../service/administracion/tipoComprobanteService';
import productoService from '../../../service/administracion/productoService';
import transferenciaService from '../../../service/logistica/transferenciaService';
import printFormatMock from "../../../common/mock/printFormatMock";
import proyectoService from '../../../service/administracion/proyectoService';
import empleadoService from '../../../service/administracion/empleadoService';
import configuracionService from '../../../service/seguridad/usuarioConfiguracionService';
import empresaService from '../../../service/administracion/empresaService';
import movimientoService from '../../../service/logistica/movimientoService';

import Header from '../../../components/Header';
import Filters from './Filters';
import FormModal from './FormModal';
import RenombrarProductoModal from './RenombrarProductoModal';
import AgregarSerieModal from './AgregarSerieModal';
import ResultList from './ResultList';
import FormModalVer from './FormModalVer';
import ImprimirModal from './ImprimirModal';
import { CREAR_ANULAR_TRA, APROBAR_ALL_TRA, VER_SERIES_LOG } from '../../../common/types/configuracionType';

import SearchProductModal from './SearchProductModal';
import { TRANSFERENCIA } from "../../../common/types/tipoComprobanteType";
var referenciaCount = 1;

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();

        this.state = {
            loadingSource: true,
            loadingPrint: false,
            loadingEdit: false,
            monedas: [],
            tiposCambioDiario: [],
            listasPrecio: [],
            establecimientos: [],
            establecimientos2: [],
            almacenes: [],
            clientes: [],
            direcciones: [],
            tiposComprobante: [],
            productos: [],
            proyectos: [],
            ordenesCompra: [],
            estados: [],
            empleados: [],
            company: {},
            configuraciones: [],
            almacenUsuario: [],
            filter: {
                fechaInicioStr: global.fetchCurrentDateStr(true),
                fechaFinStr: global.fetchCurrentDateStr(),
                idEstablecimiento: 0,
                idConcepto: 0,
                idEstado: 0,
                idEntidad: 0,
                idProyecto: 0,
                idAlmacenOrigen: 0,
                idAlmacenDestino: 0,
                documento: '',
                serie: '',
                idUsuarioRecepcion: auth.user().id,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            productoVisible: false,
            importarOCVisible: false,
            visibleVer: false,
            renombrarProductoVisible: false,
            formValues: this.fetchEmptyFormValues(),
            productoModal: {
                nombre: '',
                dataSource: [],
                selectedRowKeys: []
            },
            importarOrdenCompraModal: {
                nombre: '',
                dataSource: [],
                dataSourceDetalle: []
            },
            renombrarProductoModal: {
                nombre: '',
                idProducto: 0
            },
            onSetFieldsValue: null,
            onGetFieldValue: null,
            searchProductVisible: false,
            searchProductFormValues: {
                validarStock: false,
                dataSource: []
            },

            imprimirFormValues: {
                file: undefined,
                idMovimiento: 0,
                idFormato: 0,
                formatos: printFormatMock.values,
                response: undefined,

            },
            agregarSerieModal: {
                serie: '',
                idProducto: 0,
                listaDetalleSerie: [],
                selectedRowKeys: []
            },
        }
    }

    fetchTipoCambio = (idMoneda, tiposCambioDiario) => {
        const filter = (tiposCambioDiario ? tiposCambioDiario : this.state.tiposCambioDiario).filter(m => m.idMoneda === idMoneda);
        if (filter.length > 0)
            return parseFloat(filter[0].venta).toFixed(3);
        else
            return '0.000';
    }

    handleChangeForm = async (property, value, form) => {
        if (property === "idEstablecimiento" || property === "idAlmacen") {
            var data = form.getFieldValue(property);
            var label = property === "idEstablecimiento" ? "el establecimiento" : 'el almacén';
            if (this.state.formValues.listaComprobanteDetalle.length > 0) {
                dialog.confirm(<span>Al cambiar {label} se removera los productos agregados previamente.<br /><span>¿Deseas continuar?'</span></span>,
                    async () => {
                        if (property === "idEstablecimiento") {
                            this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
                            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
                            this.setState({
                                formValues: {
                                    ...this.state.formValues,
                                    almacenLoading: false,
                                    almacenes: almacenes ? almacenes : []
                                }
                            });
                            form.setFieldsValue({
                                idAlmacen: undefined
                            });
                        }

                        this.setState({
                            formValues: {
                                ...this.state.formValues,
                                listaComprobanteDetalle: [],
                                detalleProductos: []
                            }
                        });
                        form.setFieldsValue({
                            sumaTotalDetalle: 0,
                            sumaImporteDescuento: 0,
                            sumaSubTotal: 0,
                            sumaIgv: 0,
                            sumaIsc: 0,
                            sumaTotal: 0,
                            arrDetalle: [],
                            listaComprobanteDetalle: [],
                        });
                    }, () => form.setFieldsValue({
                        [property]: data
                    }));
            } else {
                if (property === "idEstablecimiento") {
                    this.setState({ formValues: { ...this.state.formValues, almacenLoading: true } });
                    //const almacenes = await almacenService.listarPorIdEstablecimiento(value);
                    const param = { idUsuario: auth.user().id, idTipoPermiso: 2, idEstablecimiento: value }
                    const almacenes = await configuracionService.obtenerPermisoAlmacen(param); // 2 logisitica

                    this.setState({
                        formValues: {
                            ...this.state.formValues,
                            almacenLoading: false,
                            almacenes: almacenes ? almacenes : []
                        }
                    });
                    form.setFieldsValue({
                        idAlmacen: undefined,
                        arrDetalle: [],
                        listaComprobanteDetalle: [],
                    });
                }
            }
        }

        if (property === "idEstablecimiento2") {
            //debugger
            this.setState({ formValues: { ...this.state.formValues, almacen2Loading: true } });
            const almacenes = await almacenService.listarPorIdEstablecimiento(value);
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    almacen2Loading: false,
                    almacenes2: almacenes ? almacenes : []
                }
            });
        }

        if (property === "fechaStr") {
            //const dias_vencimiento = this.CalcularDiasVencimiento(value, this.state.formValues.fechaVencimientoStr);
            const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(value);

            this.setState({
                formValues: {
                    ...this.state.formValues,
                    tipoCambio: this.fetchTipoCambio(DOLARES_AMERICANOS, tiposCambioDiario)
                    //diasVencimiento: dias_vencimiento
                }
            });
        }

        if (property === "idMoneda") {

            var data = form.getFieldValue(property);
            if (this.state.formValues.listaComprobanteDetalle.length > 0) {
                dialog.confirm(<span>Al cambiar la moneda se removera los productos agregados previamente.<br /><span>¿Deseas continuar?'</span></span>,
                    async () => {
                        this.setState({
                            formValues: {
                                ...this.state.formValues,
                                listaComprobanteDetalle: [],
                                detalleProductos: []
                            }
                        });
                        form.setFieldsValue({
                            sumaTotalDetalle: 0,
                            sumaImporteDescuento: 0,
                            sumaSubTotal: 0,
                            sumaIgv: 0,
                            sumaIsc: 0,
                            sumaTotal: 0
                        });
                    }, () => form.setFieldsValue({
                        [property]: data
                    }));
            }
        }

    }

    handleChangeNameProduct = (row) => {
        console.log(row);
        this.setState({
            renombrarProductoVisible: true,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: row.nombre,
                idProducto: row.identifier
            }
        })
    }

    handleClearFilters = () => {
        var filter = {
            fechaInicioStr: global.fetchCurrentDateStr(true),
            fechaFinStr: global.fetchCurrentDateStr(),
            idEstablecimiento: 0,
            idConcepto: 0,
            idEstado: 0,
            idEntidad: 0,
            idProyecto: 0,
            idAlmacenOrigen: 0,
            idAlmacenDestino: 0,
            documento: '',
            serie: '',
            idUsuarioRecepcion: auth.user().id,
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleOkChangeNameProduct = (value, form) => {
        var listaComprobanteDetalle_aux = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== value.idProducto);

        var currentRow = this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier === value.idProducto)[0];
        currentRow.nombre = value.nombre;
        //console.log(currentRow)
        listaComprobanteDetalle_aux.push(currentRow);

        var empty_renombrarProductoModal = {
            nombre: '',
            idProducto: 0
        };

        form.setFieldsValue(empty_renombrarProductoModal);
        form.resetFields();

        this.setState({
            renombrarProductoVisible: false,
            renombrarProductoModal: {
                ...this.state.renombrarProductoModal,
                nombre: '',
                idProducto: 0
            },
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle_aux
            }
        });
    }

    handleNew = async () => {
        var idUsuario = auth.user().id;

        var flagCrear = this.state.configuraciones.filter((m) => m.abreviatura === CREAR_ANULAR_TRA).length >= 1 ? true : false;
        if (!flagCrear) {
            message.warning('Usted no tiene permiso para crear transferencia.');
            return;
        }

        const datosIniciales = await transferenciaService.datosIniciales({
            idUsuario: idUsuario,
            idTipoComprobante: TRANSFERENCIA.ID,
        });

        var formValues = this.fetchEmptyFormValues();
        formValues.establecimientos = this.state.almacenUsuario;
        formValues.establecimientos2 = this.state.establecimientos;
        formValues.monedas = this.state.monedas;
        formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
        formValues.tiposComprobante = this.state.tiposComprobante;
        formValues.proyectos = this.state.proyectos;
        formValues.empleados = this.state.empleados;
        if (datosIniciales !== undefined) {
            formValues.serie = datosIniciales.serie;
        }

        if (formValues.serie == "" || formValues.serie == null) {
            dialog.error("Tiene que registrar serie correlativo para poder registrar la transferencia");
            return false

        }
        this.setState({
            visible: true,
            formValues,
            productoModal: {
                ...this.state.productoModal,
                selectedRowKeys: []
            }
        });
    }


    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };
    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    fetchEmptyFormValues = () => {
        //var d = new Date();
        //var _year = d.getFullYear();
        return {
            id: 0,
            //idEstablecimientoCliente: 0, //..........................................................OK
            idAlmacen: 0, //..........................................................OK
            idAlmacen2: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: 0, //..........................................................OK
            idEstablecimiento2: 0, //..........................................................OK
            idProyecto: 0,
            idMovimientoIngreso: 0,
            idMovimientoSalida: 0,
            serie: "TF01", //............................................... OK
            documento: "", //............................................... OK
            fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            idUsuarioRecepcion: 0,
            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            almacenLoading: false,
            almacen2Loading: false,
            flagTipoBusquedaScanner: 0,
            //clienteLoading: false,
            activeKey: "1",
            //documentoEntidad: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            establecimientos2: [],
            almacenes: [],
            almacenes2: [],
            proyectos: [],
            numeroValeDestino: '',
            numeroValeOrigen: '',
            empleados: [],
            numeroMovimientoIngreso: '',
            numeroMovimientoSalida: '',
            nombreMoneda: '',
            nombreEstablecimientoOrigen: '',
            nombreEstablecimientoDestino: '',
            nombreAlmacenOrigen: '',
            nombreAlmacenDestino: ''
        }
    }

    fetchEmptyResetFormValues = () => {
        //var d = new Date();
        //var _year = d.getFullYear();
        return {
            id: 0,
            //idEstablecimientoCliente: 0, //..........................................................OK
            idAlmacen: 0, //..........................................................OK
            idAlmacen2: 0, //..........................................................OK
            idMoneda: SOLES, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: 0, //..........................................................OK
            idEstablecimiento2: 0, //..........................................................OK

            idMovimientoIngreso: 0,
            idMovimientoSalida: 0,
            idProyecto: 0,
            serie: "TF01", //............................................... OK
            documento: "", //............................................... OK
            //fechaStr: global.fetchCurrentDateStr(), //......................................... OK
            idUsuarioRecepcion: 0,
            tipoCambio: 0, //..........................................................OK
            observacion: "", //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            sumaSubTotal: 0,
            sumaIgv: 0,
            sumaTotal: 0,
            almacenLoading: false,
            almacen2Loading: false,
            //clienteLoading: false,
            activeKey: "1",
            //documentoEntidad: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            establecimientos2: [],
            almacenes: [],
            almacenes2: [],
            proyectos: [],
            numeroValeDestino: '',
            numeroValeOrigen: '',
            empleados: [],

            numeroMovimientoIngreso: '',
            numeroMovimientoSalida: '',
            nombreMoneda: '',
            nombreEstablecimientoOrigen: '',
            nombreEstablecimientoDestino: '',
            nombreAlmacenOrigen: '',
            nombreAlmacenDestino: ''
        }
    }

    fetchEditFormValues = (value) => {
        //var d = new Date();
        //var _year = d.getFullYear();
        return {
            id: value.transferencia.id,
            //idEstablecimientoCliente: 0, //..........................................................OK
            idAlmacen: value.transferencia.idAlmacenOrigen, //..........................................................OK
            idAlmacen2: value.transferencia.idAlmacenDestino, //..........................................................OK
            idMoneda: value.transferencia.idMoneda, //..........................................................OK
            idListaPrecio: 0, //..........................................................OK
            idEstablecimiento: value.transferencia.idEstablecimientoOrigen, //..........................................................OK
            idEstablecimiento2: value.transferencia.idEstablecimientoDestino, //..........................................................OK
            idProyecto: value.transferencia.idProyecto,
            idMovimientoIngreso: value.transferencia.idMovimientoIngreso,
            idMovimientoSalida: value.transferencia.idMovimientoSalida,

            //serie: _year, //............................................... OK
            documento: value.transferencia.documento, //............................................... OK
            fechaStr: value.transferencia.fechaStr, //......................................... OK

            tipoCambio: value.transferencia.tipoCambio, //..........................................................OK
            observacion: value.transferencia.observacion, //..........................................................OK
            listaComprobanteDetalle: [],
            listaComprobanteReferencia: [],
            sumaSubTotal: value.transferencia.subTotal,
            sumaIgv: value.transferencia.igv,
            sumaTotal: value.transferencia.total,
            almacenLoading: false,
            almacen2Loading: false,
            //clienteLoading: false,
            activeKey: "1",
            //documentoEntidad: "",
            monedas: [],
            listasPrecio: [],
            establecimientos: [],
            establecimientos2: [],
            almacenes: [],
            almacenes2: [],
            proyectos: [],
            numeroValeDestino: value.transferencia.numeroMovimientoSalida,
            numeroValeOrigen: value.transferencia.numeroMovimientoIngreso,

            numeroMovimientoIngreso: value.transferencia.numeroMovimientoIngreso,
            numeroMovimientoSalida: value.transferencia.numeroMovimientoSalida,
            nombreMoneda: value.transferencia.nombreMoneda,
            nombreEstablecimientoOrigen: value.transferencia.nombreEstablecimientoOrigen,
            nombreEstablecimientoDestino: value.transferencia.nombreEstablecimientoDestino,
            nombreAlmacenOrigen: value.transferencia.nombreAlmacenOrigen,
            nombreAlmacenDestino: value.transferencia.nombreAlmacenDestino
        }
    }

    handleChangeTab = (key) => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                activeKey: key
            }
        });
    };

    handleAgregarDetalle = (onSetFieldsValue, onGetFieldValue) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue
        }, () => {
            if (this.state.formValues.activeKey === "1")
                this.handleOpenSearchProductModal();

            if (this.state.formValues.activeKey === "2")
                this.handleAddReferencia();
        });
    };

    handleOpenSearchProductModal = async () => {
        debugger;
        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');

        if (idAlmacen === undefined || idAlmacen.key === 0) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        var filter = {
            idAlmacen: idAlmacen === undefined ? 0 : idAlmacen.key,
            idMoneda: idMoneda === undefined ? 0 : idMoneda.key,
            idSistema: LOGISTICA
        }

        const response = await productoService.stock(filter);

        if (response.validarStock === false) {
            message.warning("No se encuentran productos en stock.");
            return;
        }

        console.log(response)
        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                dataSource: response.productos
            }
        });
    };

    getMinDate = (value) => {
        var arrayD1 = value.split('/');
        var minDate = arrayD1[2] + "/" + arrayD1[1] + "/" + arrayD1[0];

        return minDate;
    }


    handleScaner = async (value, onSetFieldsValue, onGetFieldValue, onCalculateDetail) => {
        this.setState({
            onSetFieldsValue,
            onGetFieldValue,
        });
        var idEstablecimiento = this.state.onGetFieldValue('idEstablecimiento');
        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');
        var flagTipoBusquedaScanner = this.state.onGetFieldValue('flagTipoBusquedaScanner');

        if (idEstablecimiento === undefined) {
            message.warning('Por favor seleccione un establecimiento.');
            return;
        }

        if (idAlmacen === undefined) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        if (idMoneda === undefined) {
            message.warning('Por favor seleccione la moneda.');
            return;
        }

        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;

        if (this.state.agregarSerieVisible) { // SE AGREGA SERIE MENDIANTE EL POPUP ASIGNAR SERIE

            var filter_producto_detalle = listaComprobanteDetalle.filter((m) => m.idProducto === this.state.agregarSerieModal.idProducto)[0];

            if (filter_producto_detalle.listaDetalleSerie.filter(m => m.serie === value).length > 0) {
                message.warning('La serie ya ha sido agregada.');
                return;
            }

            var listaSerieProducto = await movimientoService.listarSeriesDisponibles({ idAlmacen: idAlmacen.key, idProducto: this.state.agregarSerieModal.idProducto, numeroLote: filter_producto_detalle.lote });
            var serieProducto = listaSerieProducto.filter(m => m.serie === value);

            if (serieProducto.length === 0) {
                message.warning('El número de serie no existe.');
                return;
            }

            filter_producto_detalle.listaDetalleSerie.push(serieProducto[0]);
            debugger;
            var selected = filter_producto_detalle.listaDetalleSerie.map(m => m.serie);

            this.handleChangeSelectedSerie(selected, filter_producto_detalle.listaDetalleSerie, onCalculateDetail, 0);

            return;
        }
        else if (flagTipoBusquedaScanner === 0) // BUSQUEDA DE PRODUCTO POR CODIGO DE BARRA
        {
            //SE AGREGA PRODUCTO POR CODIGO DE BARRA 

            var filter_detalle = listaComprobanteDetalle.filter((m) => m.codigoBarra === value);

            const index = listaComprobanteDetalle.map(i => i.codigoBarra).indexOf(value);

            var item = {};
            if (filter_detalle.length > 0) {
                listaComprobanteDetalle = listaComprobanteDetalle.filter((m) => m.codigoBarra !== value);

                var item = filter_detalle[0];

                if (item.flagAplicarSerie) {
                    dialog.error("El producto ya se encuentra agregado.");
                    return;
                }

                var item = filter_detalle[0];
                var _cantidad = this.state.onGetFieldValue(`arrCantidad[${item.identifier}]`);

                item.cantidad = parseInt(_cantidad,) + 1;
            } else {

                var filter = {
                    idAlmacen: idAlmacen === undefined ? 0 : idAlmacen.key,
                    idMoneda: idMoneda === undefined ? 0 : idMoneda.key,
                    idSistema: LOGISTICA,
                    barcode: value,
                }

                var list = await productoService.stock(filter);

                var filter_list = list.productos.filter((m) => m.codigoBarra === value);

                if (filter_list.length === 0) {
                    dialog.error("No existe el producto con codigo " + value + "\n" + "o no cuenta con stock");
                    return;
                }

                item = this.setDetalleByProductoStock(filter_list[0]);
            }

            listaComprobanteDetalle.splice(index, 0, item);

            this.setState(
                {
                    formValues: {
                        ...this.state.formValues,
                        listaComprobanteDetalle: listaComprobanteDetalle
                    },
                },
                () => {
                    onCalculateDetail(item, "arrCantidad", item.cantidad, 3);
                }
            );
            message.success("Producto agregado");
        }
        else if (flagTipoBusquedaScanner === 1)  // BUSQUEDA DE PRODUCTO POR SERIE
        {
            debugger;
            var listaSerieProducto = await movimientoService.listarSeriesDisponiblesBySerie({ idAlmacen: idAlmacen.key, serie: value });

            if (listaSerieProducto.length === 0) {
                message.warning('El número de serie no existe.');
                return;
            }

            var count_productos_by_serie = listaSerieProducto.map(item => item.idProducto).filter((value, index, self) => self.indexOf(value) === index);

            if (count_productos_by_serie.length > 1) {
                message.warning('La serie tiene asociado mas de un producto, no se puede escanear.');
                return;
            }

            var serieProducto = listaSerieProducto[0];

            var comprobanteDetalle_filter = listaComprobanteDetalle.filter(m => m.idProducto === serieProducto.idProducto && m.numeroLote == serieProducto.numeroLote);
            debugger;
            var item = {};
            if (comprobanteDetalle_filter.length > 0) {
                item = comprobanteDetalle_filter[0];

                if (item.listaDetalleSerie.filter(m => m.serie === value).length > 0) {
                    message.warning('La serie ya ha sido agregado.');
                    return;
                }

                var _precioUnitario = this.state.onGetFieldValue(`arrPrecioUnitario[${item.identifier}]`);
                var _cantidad = this.state.onGetFieldValue(`arrCantidad[${item.identifier}]`);

                item.cantidad = parseInt(_cantidad,) + 1;
                item.listaDetalleSerie.push(serieProducto);
                item.precioUnitario = parseFloat(_precioUnitario);

                var listaComprobanteDetalleFilter = listaComprobanteDetalle.filter(m => m.identifier != item.identifier);

                listaComprobanteDetalleFilter.push(item);

                listaComprobanteDetalle = listaComprobanteDetalleFilter;

            } else {
                var filter = {
                    idAlmacen: idAlmacen === undefined ? 0 : idAlmacen.key,
                    idMoneda: idMoneda === undefined ? 0 : idMoneda.key,
                    idSistema: LOGISTICA,
                    barcode: ''
                }

                const response = await productoService.stock(filter);

                var producto = response.productos.filter(m => m.id === serieProducto.idProducto && m.numeroLote === serieProducto.numeroLote)[0];

                item = this.setDetalleByProductoStock(producto);

                item.listaDetalleSerie.push(serieProducto);
                item.detalleSeries = item.listaDetalleSerie.map(u => u.serie).join(', ');
                item.cantidad = item.listaDetalleSerie.length;

                listaComprobanteDetalle.push(item);
            }

            var selected = item.listaDetalleSerie.map(m => m.serie);

            this.setState(
                {
                    formValues: {
                        ...this.state.formValues,
                        listaComprobanteDetalle: listaComprobanteDetalle
                    },
                },
                () => {
                    this.handleChangeSelectedSerie(selected, item.listaDetalleSerie, onCalculateDetail, 0);
                }
            );
        }




    };

    setDetalleByProductoStock = (row) => {
        var item = {
            identifier: global.fetchUniqueCode(),
            idProducto: row.id,
            codigo: row.codigoReferencia,
            codigoBarra: row.codigoBarra,
            nombre: row.nombre,
            numeroLote: row.numeroLote,
            nombreUnidadMedida: row.nombreUnidadMedida,
            flagAfecto: row.flagIGVAfecto,
            flagAplicarSerie: row.flagAplicarSerie,
            numeroRegistroSanitario: row.numeroRegistroSanitario,
            fechaVencimiento: row.fechaVencimientoStr == null ? global.fetchCurrentDateStr() : row.fechaVencimientoStr,
            fechaProduccion: row.fechaProduccionStr,
            precioUnitario: row.precioPromedio,
            precioPromedio: row.precioPromedio,
            cantidad: 1,
            subTotal: 0,
            igv: 0,
            total: 0,
            minFechaStr: this.getMinDate(this.state.formValues.fechaStr),
            stock: row.stockDisponible,
            id: 0,
            listaDetalleSerie: []
        };
        return item;
    };

    handleSelectProduct = (row) => {
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;
        var producto = listaComprobanteDetalle.filter(e => e.nombre == row.nombre && e.lote == row.numeroLote);
        debugger;
        if (producto.length > 0) {
            message.error("No se puede duplicar el producto");

            return false;
        }

        var dateVcto = row.flagVencimiento ? row.fechaVencimientoStr : null;

        var item = {
            identifier: global.fetchUniqueCode(),
            idProducto: row.id,
            codigo: row.codigoReferencia,
            nombre: row.nombre,
            numeroLote: row.numeroLote,
            codigoBarra: row.codigoBarra,
            nombreUnidadMedida: row.nombreUnidadMedida,
            flagAfecto: row.flagIGVAfecto,
            flagAplicarSerie: row.flagAplicarSerie,
            numeroRegistroSanitario: row.numeroRegistroSanitario,
            fechaVencimiento: dateVcto,
            flagVencimiento: row.flagVencimiento,
            fechaProduccion: row.fechaProduccionStr,
            precioUnitario: row.precioPromedio,
            valorUnitario: 0,
            precioPromedio: row.precioPromedio,
            listaDetalleSerie: [],
            cantidad: 0,
            subTotal: 0,
            igv: 0,
            total: 0,
            minFechaStr: this.getMinDate(this.state.formValues.fechaStr),
            stock: row.stockDisponible,

            id: 0
        };

        listaComprobanteDetalle.push(item);

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle
            }
        }
            //, () => {
            //var producto = {
            //    identifier: item.identifier,
            //    idProducto: item.idProducto,
            //    nombre: item.nombre,
            //    cantidad: item.cantidad,
            //    precioUnitarioSinIGV: 0,
            //    precioUnitario: item.precioUnitario,
            //    porcentajeDescuento: item.porcentajeDescuento,
            //    importeDescuento: item.importeDescuento,
            //    total: item.total,
            //    flagAfecto: item.flagAfecto,
            //    flagISC: item.flagISC,
            //    flagOtrosImpuesto: false,
            //    flagGratuito: item.flagGratuito,
            //    flagChangeTotal: false,
            //    subTotal: 0,
            //    numeroLote: row.numeroLote
            //};

            //var detalleProductos = this.state.onGetFieldValue('detalleProductos');
            //detalleProductos.push(producto);
            //this.state.onSetFieldsValue({ detalleProductos });
            //}
        );
    };

    handleRemoverProducto = (identifier) => {

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: this.state.formValues.listaComprobanteDetalle.filter(m => m.identifier !== identifier)
            },
        }//,
            //() => {
            //    var detalleProductos = this.state.onGetFieldValue('detalleProductos');
            //    this.state.onSetFieldsValue({
            //        detalleProductos: detalleProductos.filter(m => m.identifier !== row.identifier)
            //    });
            //}
        );
    };

    handleAddReferencia = () => {
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia;

        listaComprobanteReferencia.push({
            identifier: referenciaCount,
            idReferencia: 0,
            idReferenciaOrigen: 0,
            idTipoComprobante: 0,
            series: "",
            documentos: "",
            flagInterno: true
        });

        referenciaCount = referenciaCount + 1;

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            }
        });
    };

    handleRemoverReferencia = (id) => {
        console.log(id);
        var listaComprobanteReferencia = this.state.formValues.listaComprobanteReferencia.filter(m => m.identifier !== id.identifier);
        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteReferencia: listaComprobanteReferencia
            },
        });
    }


    handleSave = async (values, form) => {
        if (values.idAlmacenOrigen === values.idAlmacenDestino) {
            message.warning('Debe seleccionar un almacén diferente para la transferencia.');
            return;
        }

        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {


            if (values.transferenciaDetalles !== undefined) {
                for (var i = 0; i < values.transferenciaDetalles.length; i++) {
                    var item = this.state.formValues.listaComprobanteDetalle.filter(m => m.idProducto === values.transferenciaDetalles[i].idProducto)[0];
                    values.transferenciaDetalles[i].nombre = item.nombre;
                }
            }

            var response;
            if (values.id === 0 || values.id === undefined)
                response = await transferenciaService.registrar(values);
            else
                response = await transferenciaService.modificar(values);

            if (response.status === 200) {
                var empty = this.fetchEmptyResetFormValues();
                this.setState({ visible: false, formValues: empty });
                form.setFieldsValue(empty);
                form.resetFields();

                if (values.id === 0)
                    message.success('Registrado correctamente.');
                else
                    message.success('Modificado correctamente.');

                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    handleExportExcel = async () => {
        var response = await transferenciaService.excel(this.state.filter);
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Transferencias.xlsx");
    }



    handleChangeImprimir = async (idFormato) => {
        debugger
        var file = undefined;
        var response = undefined;
        var id = this.state.imprimirFormValues.idMovimiento;

        if (idFormato === 1) {
            response = await transferenciaService.pdfA4({ id: id });
            file = window.URL.createObjectURL(response.data);
        }

        if (idFormato === 2) {
            response = await transferenciaService.pdfTicket({ id: id });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
            },
        });
    };


    handleImprimir = async (item) => {
        this.setState({ loadingPrint: true });
        var idFormato = this.state.company.formatoPrint;

        var file = undefined;
        var response;
        if (idFormato === 1) {
            response = await transferenciaService.pdfA4({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }
        if (idFormato === 2) {
            response = await transferenciaService.pdfTicket({ id: item.id });
            file = window.URL.createObjectURL(response.data);
        }

        this.setState({
            imprimirVisible: true,
            loadingPrint: false,
            imprimirFormValues: {
                ...this.state.imprimirFormValues,
                idFormato,
                file,
                idMovimiento: item.id
            }
        });
    };

    handleEdit = async (values) => {
        this.setState({ loadingEdit: true });
        const response = await transferenciaService.obtenerPorId(values.id);
        if (response !== undefined) {
            console.log(response);
            const almacenes1 = await almacenService.listarPorIdEstablecimiento(response.transferencia.idEstablecimientoOrigen);
            const almacenes2 = await almacenService.listarPorIdEstablecimiento(response.transferencia.idEstablecimientoDestino);

            var formValues = this.fetchEditFormValues(response);
            formValues.establecimientos = this.state.establecimientos;
            formValues.establecimientos2 = this.state.establecimientos2;
            formValues.monedas = this.state.monedas;
            formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
            formValues.almacenes = almacenes1;
            formValues.almacenes2 = almacenes2;
            formValues.tiposComprobante = this.state.tiposComprobante;
            formValues.proyectos = this.state.proyectos;

            const products = [];
            for (var i = 0; i < response.transferenciaDetalles.length; i++) {
                var item = response.transferenciaDetalles[i];
                var oneProd = {
                    id: item.id,
                    identifier: global.fetchUniqueCode(),
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    //precioUnitarioSinIGV: 0,
                    subTotal: item.subTotal,
                    igv: item.igv,
                    numeroLote: item.numeroLote,
                    fechaVencimiento: item.fechaStr
                }

                formValues.listaComprobanteDetalle.push(oneProd);

                products.push(item.idProducto);
            }



            for (var i = 0; i < response.transferenciaReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.transferenciaReferencias[i];
                var oneRef = {
                    identifier: referenciaCount,
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }

            this.setState({
                visible: true,
                loadingEdit: false,
                formValues,
                //productos: productos ? productos : [],
                productoModal: {
                    ...this.state.productoModal,
                }
            });
        }
    }

    handleVer = async (values) => {
        const response = await transferenciaService.obtenerPorId(values.id);
        if (response !== undefined) {
            console.log(response);
            const almacenes1 = await almacenService.listarPorIdEstablecimiento(response.transferencia.idEstablecimientoOrigen);
            const almacenes2 = await almacenService.listarPorIdEstablecimiento(response.transferencia.idEstablecimientoDestino);

            var formValues = this.fetchEditFormValues(response);
            formValues.establecimientos = this.state.establecimientos;
            formValues.establecimientos2 = this.state.establecimientos2;
            formValues.monedas = this.state.monedas;
            formValues.tipoCambio = this.fetchTipoCambio(DOLARES_AMERICANOS);
            formValues.almacenes = almacenes1;
            formValues.almacenes2 = almacenes2;
            formValues.empleados = this.state.empleados;
            formValues.recepcion = values.recepcion;
            formValues.proyecto = values.proyecto;


            const products = [];
            for (var i = 0; i < response.transferenciaDetalles.length; i++) {
                var item = response.transferenciaDetalles[i];
                var oneProd = {
                    id: item.id,
                    identifier: global.fetchUniqueCode(),
                    idProducto: item.idProducto,
                    nombre: item.nombre,
                    cantidad: item.cantidad,
                    codigo: item.codigoReferencia,
                    nombreUnidadMedida: item.nombreUnidadMedida,
                    precioUnitario: item.precioUnitario,
                    total: item.total,
                    flagAfecto: item.flagAfecto,
                    //precioUnitarioSinIGV: 0,
                    subTotal: item.subTotal,
                    igv: item.igv,
                    numeroLote: item.numeroLote,
                    fechaVencimiento: item.fechaVencimientoStr,
                    fechaProduccion: item.fechaProduccionStr,
                    numeroRegistroSanitario: item.numeroRegistroSanitario
                }

                formValues.listaComprobanteDetalle.push(oneProd);

                products.push(item.idProducto);
            }



            for (var i = 0; i < response.transferenciaReferencias.length; i++) {
                referenciaCount = i + 1;
                var item = response.transferenciaReferencias[i];
                var oneRef = {
                    identifier: referenciaCount,
                    idReferencia: item.id,
                    idReferenciaOrigen: item.idReferenciaOrigen,
                    idTipoComprobante: item.idTipoComprobante,
                    serie: item.serie,
                    documento: item.documento,
                    flagInterno: true
                }
                formValues.listaComprobanteReferencia.push(oneRef);
            }

            this.setState({
                visibleVer: true,
                formValues
            });
        }
    }

    handleAnular = async (values) => {
        var flagAprobarAll = this.state.configuraciones.filter((m) => m.abreviatura === APROBAR_ALL_TRA).length >= 1 ? true : false;
        var flagAprobar = this.state.configuraciones.filter((m) => m.abreviatura === CREAR_ANULAR_TRA).length >= 1 ? true : false;

        if (flagAprobarAll || flagAprobar) {

            if (!flagAprobarAll) {
                if (values.idRecepcion != auth.user().id) {
                    message.warning('Usted no puede anular la transferencia');
                    return;
                }
            }

            dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
                var response = await transferenciaService.eliminar(values);

                if (response.status === 200) {
                    message.success('Proceso realizado correctamente.');
                    this._handlePagination(this.state.filter);
                    return;
                }

                if (response.status === 400) {
                    dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                    return;
                }

                dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
            });
            return
        }
        message.warning('Usted no puede aprobar la transferencia');

    }

    handleAprobar = async (values) => {
        var flagAprobarAll = this.state.configuraciones.filter((m) => m.abreviatura === APROBAR_ALL_TRA).length >= 1 ? true : false;
        var flagAprobar = this.state.configuraciones.filter((m) => m.abreviatura === CREAR_ANULAR_TRA).length >= 1 ? true : false;

        if (flagAprobarAll || flagAprobar) {

            if (!flagAprobarAll) {
                if (values.idRecepcion != auth.user().id) {
                    message.warning('Usted no puede aprobar la transferencia');
                    return;
                }
            }

            dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
                var response = await transferenciaService.aprobar(values);

                if (response.status === 200) {
                    message.success('Proceso realizado correctamente.');
                    this._handlePagination(this.state.filter);
                    return;
                }

                if (response.status === 400) {
                    dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                    return;
                }

                dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
            });
            return
        }
        message.warning('Usted no puede aprobar la transferencia');

    }

    handleBuscarProducto = async (value) => {

        var idAlmacen = this.state.onGetFieldValue('idAlmacen');
        var idMoneda = this.state.onGetFieldValue('idMoneda');

        if (idAlmacen === undefined || idAlmacen.key === 0) {
            message.warning('Por favor seleccione un almacén.');
            return;
        }

        var filter = {
            idAlmacen: idAlmacen === undefined ? 0 : idAlmacen.key,
            idMoneda: idMoneda === undefined ? 0 : idMoneda.key,
            idSistema: LOGISTICA,
            codigoNombre: value
        }

        const response = await productoService.stock(filter);
        this.setState({
            searchProductVisible: true,
            searchProductFormValues: {
                ...this.state.searchProductFormValues,
                validarStock: response.validarStock,
                dataSource: response.productos
            }
        });
    };

    handleAgregarSerie = async (row, onCalculateDetail, setFieldsValueDetalle, getFieldValueDetalle) => {
        debugger;
        var idAlmacen = this.state.onGetFieldValue('idAlmacen').key;
        var listaSerieProducto = await movimientoService.listarSeriesDisponibles({ idAlmacen: idAlmacen, idProducto: row.idProducto, numeroLote: row.numeroLote });

        this.setState({
            setFieldsValueDetalle,
            getFieldValueDetalle
        }, async () => {
            debugger;
            this.setState({
                agregarSerieVisible: true,
                agregarSerieModal: {
                    ...this.state.agregarSerieModal,
                    idProducto: row.idProducto,
                    serie: '',
                    codigoProducto: row.codigo,
                    nombreProducto: row.nombre,
                    listaDetalleSerie: listaSerieProducto,
                    onCalculateDetail: onCalculateDetail,
                    setFieldsValueDetalle: setFieldsValueDetalle,
                    getFieldValueDetalle: getFieldValueDetalle,
                    selectedRowKeys: row.selectedSerie
                }
            });

        });
    }

    handleChangeSelectedSerie = (selected, rows, onCalculateDetail, idProductoRemoveSerie) => {
        debugger;
        var listaComprobanteDetalle = this.state.formValues.listaComprobanteDetalle;

        if (selected.length > 0) {
            listaComprobanteDetalle.forEach(detalle => {
                debugger;
                if (detalle.idProducto === rows[0].idProducto) {
                    detalle.selectedSerie = selected;
                    detalle.listaDetalleSerie = rows;
                    detalle.detalleSeries = detalle.listaDetalleSerie.map(u => u.serie).join(', ');
                    detalle.cantidad = detalle.listaDetalleSerie.length;
                    onCalculateDetail(detalle, "arrCantidad", detalle.cantidad, 3);
                }
            });
        } else {
            listaComprobanteDetalle.forEach(detalle => {
                debugger;
                if (detalle.idProducto === idProductoRemoveSerie) {
                    detalle.selectedSerie = [];
                    detalle.listaDetalleSerie = [];
                    detalle.detalleSeries = '';
                    detalle.cantidad = detalle.listaDetalleSerie.length;
                    onCalculateDetail(detalle, "arrCantidad", detalle.cantidad, 3);
                }
            });
        }

        this.setState({
            formValues: {
                ...this.state.formValues,
                listaComprobanteDetalle: listaComprobanteDetalle,
                arrDetalle: listaComprobanteDetalle
            },
            agregarSerieModal: {
                ...this.state.agregarSerieModal,
                selectedRowKeys: selected
            }
        });
    };

    async componentDidMount() {

        var idUsuario = auth.user().id;
        const empresa = await empresaService.obtenerPrincipal(0);

        const datosIniciales = await transferenciaService.datosIniciales({ idUsuario: idUsuario, idTipoComprobante: TRANSFERENCIA.ID, });
        const configuraciones = await configuracionService.obtenerPorModulo({ idUsuario: idUsuario, idModulo: 3 });
        var flagSerie = configuraciones.filter((m) => m.abreviatura === VER_SERIES_LOG).length >= 1 ? true : false;

        const serie = [undefined, null].includes(datosIniciales?.serie) ? flagSerie ? '' : '-' : datosIniciales.serie;

        this.setState({ filter: { ...this.state.filter, serie } });

        this._initPagination({ ...this.state.filter, serie }, transferenciaService.paginacion);

        const almacenUsuario = await configuracionService.obtenerPermisoEstablecimiento({ idUsuario: idUsuario, idTipoPermiso: 2 }); // 2 logisitica

        const monedas = await monedaService.listar();
        const tiposCambioDiario = await tipoCambioDiarioService.listarPorFecha(global.fetchCurrentDateStr());
        const listasPrecio = await listaPrecioService.listar();
        const almacen = await almacenService.listarPorIdEstablecimiento(-1);
        const establecimientos = await establecimientoService.principales();
        //const establecimientos = await establecimientoService.principales();
        //const vendedores = await vendedorService.listar();
        const tiposComprobante = await tipoComprobanteService.listar();
        const proyectos = await proyectoService.listar();
        const estados = await transferenciaService.listarEstado();
        const empleados = await empleadoService.listarEmpleadoSistema();

        //const conceptos = await conceptoService.listar();

        this.setState({
            loadingSource: false,
            tiposCambioDiario: tiposCambioDiario ? tiposCambioDiario : [],
            monedas: monedas ? monedas : [],
            listasPrecio: listasPrecio ? listasPrecio : [],
            almacenes: almacen ? almacen : [],
            establecimientos: establecimientos ? establecimientos : [],
            establecimientos2: establecimientos ? establecimientos : [],
            configuraciones: configuraciones ? configuraciones : [],
            tiposComprobante: tiposComprobante ? tiposComprobante : [],
            proyectos: proyectos ? proyectos : [],
            empleados: empleados ? empleados : [],
            estados: estados ? estados : [],
            almacenUsuario: almacenUsuario ? almacenUsuario : [],
            company: empresa,
        });
    }

    render() {
        return (
            <div>
                <Header
                    title="Transferencias"
                    onNew={this.handleNew}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination(this.state.filter)}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                    proyectos={this.state.proyectos}
                    almacenes={this.state.almacenes}
                    estados={this.state.estados}
                    configuraciones={this.state.configuraciones}

                />

                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingEdit}
                    loadingPrint={this.state.loadingPrint}
                    loadingAnular={this.state.loadingSource}
                    onExportExcel={this.handleExportExcel}
                    onVer={this.handleVer}
                    onEditar={this.handleEdit}
                    onAnular={this.handleAnular}
                    onAprobar={this.handleAprobar}
                    onImprimir={this.handleImprimir}
                    onChange={this._handleChangePagination}
                />

                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onAgregarDetalle={this.handleAgregarDetalle}
                    onRemoverProducto={this.handleRemoverProducto}
                    onRemoverReferencia={this.handleRemoverReferencia}
                    onChangeTab={this.handleChangeTab}
                    onChange={this.handleChangeForm}
                    onAgregarSerie={this.handleAgregarSerie}
                    onScanerProduct={this.handleScaner}
                    configuraciones={this.state.configuraciones}
                    onBlur={this.handleChangeForm}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                    onChangeNameProduct={this.handleChangeNameProduct}
                />

                <FormModalVer
                    visible={this.state.visibleVer}
                    formValues={this.state.formValues}
                    onChangeTab={this.handleChangeTab}
                    onClose={() => this.setState({ visibleVer: false })}
                />

                <RenombrarProductoModal
                    visible={this.state.renombrarProductoVisible}
                    formValues={this.state.renombrarProductoModal}
                    onCancel={() => this.setState({ renombrarProductoVisible: false })}
                    onSaveRename={this.handleOkChangeNameProduct}
                />
                <SearchProductModal
                    visible={this.state.searchProductVisible}
                    onBuscarProducto={this.handleBuscarProducto}
                    validarStock={this.state.searchProductFormValues.validarStock}
                    idSistema={LOGISTICA}//LOGISTICA
                    dataSource={this.state.searchProductFormValues.dataSource}
                    onSelect={this.handleSelectProduct}
                    onCancel={() => this.setState({ searchProductVisible: false })}
                />
                <ImprimirModal
                    visible={this.state.imprimirVisible}
                    formValues={this.state.imprimirFormValues}
                    onChange={this.handleChangeImprimir}
                    onClose={() => this.setState({ imprimirVisible: false })}
                />

                <AgregarSerieModal
                    visible={this.state.agregarSerieVisible}
                    formValues={this.state.agregarSerieModal}
                    onCancel={() => this.setState({ agregarSerieVisible: false })}
                    onAgregarSerieDetalle={this.handleChangeSelectedSerie}
                    onRemove={this.handleRemoverSerieDetalle}
                />

            </div>
        )
    }
}